import React, { FC } from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { Patient } from '../../../../types/FHIRTypes/Patient'
import HumanName from '../../DataTypes/HumanName'

type IPSProps = {
    patientData: Patient | undefined;
}

const IPS: FC<IPSProps> = ({ patientData }) => {
    return (
        <section>
            <dl className='dataContainer'>
                <h4 className="fw-bold">International Patient Summary</h4>
                <div className="ms-3">
                    <h4 className="fw-bold text-dark"><HumanName data={patientData?.name} /></h4>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Allergy/Intolerance:</h5>
                                <span className="ms-2 fs-4">  Allergy to Amoxicillin</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                        <Col sm={12} className="text-muted ps-3">SNOMED CT 447562003</Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Condition:</h5>
                                <span className="ms-2 fs-4"> History of Atrial Fibrillation</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                        <Col sm={12} className="text-muted ps-3">SNOMED CT 312442005</Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Current Medication:</h5>
                                <span className="ms-2 fs-4"> Atorvastatin 40 mg oral tablet</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                        <Col sm={12} className="text-muted ps-3">SNOMED CT 20448711000001108</Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Recent Immunization:</h5>
                                <span className="ms-2 fs-4"> Influenza virus vaccine, trivalent (IIV3), split virus, 0.5 mL dosage, for intramuscular use, 2024-03-14</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                        <Col sm={12} className="text-muted ps-3">SNOMED CT 86198006</Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Recent Immunization:</h5>
                                <span className="ms-2 fs-4"> SARS-CoV-2 vaccination, 2024-03-14</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                        <Col sm={12} className="text-muted ps-3">SNOMED CT 86155577700</Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Recent Observation Result:</h5>
                                <span className="ms-2 fs-4"> None</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Recent Procedure:</h5>
                                <span className="ms-2 fs-4"> None</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                    </Row>

                    <Row className="mb-2">
                        <Col sm={12} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-0 fw-bold d-inline">Device:</h5>
                                <span className="ms-2 fs-4"> None</span>
                            </div>
                            <a href="#"><span className="text-muted">Detail</span></a>
                        </Col>
                    </Row>
                </div>
                <Row>
                    <Col sm={12} className='footer'>
                        <hr />
                        <Col sm={12}>
                            <div className="mb-1">
                                <span className='fw-semibold'>Subject:</span> <span className='d-inline-block fw-normal'><HumanName data={patientData?.name} /></span> &nbsp;&nbsp;
                                <span className='fw-semibold'>Author:</span> Joan Nelson, MD &nbsp;&nbsp;
                                <span className='fw-semibold'>Attestor:</span> NWSpruceHospital &nbsp;&nbsp;
                                <span className='fw-semibold'>Custodian:</span> Spruce Health
                            </div>

                            <p className="mb-0">
                                <strong>Most Recent: 2025-02-25</strong> &nbsp;&nbsp;
                                <a href="#" className="text-primary"><span className="text-muted">View IPS History</span></a>
                            </p>
                        </Col>
                    </Col>
                </Row>
            </dl>
        </section>
    )
}

export default IPS

